import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import service from "../../utils/service";
const initialState = { 
 // consultation_answers: [],
  selectedTab : "this_month",
  consultationTab : "upcoming",
  carePatientData:{},
  carePatientDatafrom:""
};

const consultationReducer = createSlice({
  name: "consultationReducer",
  initialState,
  reducers: {   
    setSelectedTab(state,action){
      state.selectedTab = action.payload;
    },
    setConsultationTab(state,action){
      state.consultationTab = action.payload;
    },
    setCarePatientData(state,action){
      state.carePatientData = action.payload;
    },
    setCarePatientFrom(state,action){
      state.carePatientDatafrom = action.payload;
    }
  },
});
export const {  setSelectedTab, setConsultationTab,setCarePatientData,setCarePatientFrom } = consultationReducer.actions;
export default consultationReducer.reducer;
